import { ActionTypes } from "@/App/constants/actionTypes";
import { BatchTestClaimTypes } from "@/types";

type GetTestClaim = {
  type: typeof ActionTypes.GET_BATCH_TRANSMISSION_TEST_CLAIM;
  payload: string;
};

export const getTestClaim = (id: string): GetTestClaim => {
  return {
    type: ActionTypes.GET_BATCH_TRANSMISSION_TEST_CLAIM,
    payload: id,
  };
};

type GetTestClaimResultAction = {
  type: typeof ActionTypes.GET_BATCH_TRANSMISSION_TEST_CLAIM_RESULTS;
  payload: BatchTestClaimTypes.BatchTestClaim;
};

export const getTestClaimResults = (data: BatchTestClaimTypes.BatchTestClaim): GetTestClaimResultAction => {
  return {
    type: ActionTypes.GET_BATCH_TRANSMISSION_TEST_CLAIM_RESULTS,
    payload: data,
  };
};

export type GetBatchTestClaimActions = GetTestClaim | GetTestClaimResultAction;
